import { Component, HostListener } from '@angular/core';
import { StorageService } from '@services';

interface SocialIcon {
  classes: string;
  url?: string;
  name?: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  isDropdownOpen = false;
  public company: any;
  public today: Date = new Date();
  public metaData: any = {};

  // Todos los iconos sociales
  socialIcons: SocialIcon[] = [
    { classes: 'fab fa-facebook-f text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-twitter text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-instagram text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-linkedin-in text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-youtube text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-tiktok text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-pinterest-p text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-whatsapp text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-telegram-plane text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fab fa-brands fa-vimeo text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fa-brands fa-line text-gray-600 text-sm', url: '', name: '' },
    { classes: 'fa-brands fa-viber text-gray-600 text-sm', url: '', name: '' },
    { classes: 'newicon-icon-signal text-gray-600 text-sm', url: '', name: '' }
  ];

  constructor(private storageService: StorageService) { }

  ngOnInit(): void {
    this.company = this.storageService.get('company');
    this.metaData = this.company.experience.metaData;
    console.log("metaData", this.metaData);

    const socialFields = this.metaData?.socialNetworks?.fields || {};

    const allIconsMap = new Map<string, SocialIcon>(
      this.socialIcons.map(icon => {
        // Extraer el nombre base del ícono desde la clase (ej: 'facebook' desde 'fab fa-facebook-f')
        const name = this.extractSocialName(icon.classes);
        return [name, { ...icon }];
      })
    );

    // Filtrar y construir la lista final con solo los íconos visibles
    this.socialIcons = Object.entries(socialFields)
      .filter(([_, data]: any) => data?.visible)
      .map(([key, data]: any) => {
        const icon = allIconsMap.get(key);
        return icon
          ? {
            ...icon,
            url: data.value || '', // valor como URL
            name: key
          }
          : null;
      })
      .filter(Boolean) as SocialIcon[];
  }

  // Extrae el nombre base desde la clase del ícono (como 'facebook', 'twitter', etc.)
  private extractSocialName(classes: string): string {
    const platforms = [
      'facebook', 'twitter', 'instagram', 'linkedin', 'youtube',
      'tiktok', 'pinterest', 'whatsapp', 'telegram', 'vimeo',
      'line', 'viber', 'signal', 'x'
    ];

    for (const platform of platforms) {
      if (classes.includes(platform)) {
        return platform;
      }
    }
    return '';
  }

  // Iconos principales (primeros 5)
  get mainSocialIcons(): SocialIcon[] {
    return this.socialIcons.slice(0, 5);
  }

  // Iconos para el dropdown (restantes)
  get dropdownSocialIcons(): SocialIcon[] {
    return this.socialIcons.slice(5);
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event): void {
    if (!this.isDropdownOpen) return;

    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-button') && !target.closest('.dropdown-menu')) {
      this.isDropdownOpen = false;
    }
  }

  onDropdownClick(event: Event): void {
    event.stopPropagation();
  }

  //alineacion primera columna // contac
  get hasContactData(): boolean {
    const fields = this.metaData?.contact?.fields || {};
    return (
      fields.address?.visible ||
      fields.contactForm?.visible ||
      fields.email?.visible ||
      fields.phone?.visible ||
      fields.website?.visible
    );
  }

  

}



